import useFormatterPrice from '@/src/utils/formatter-price';
import getOption from '@/src/utils/getOption';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { MdClose } from 'react-icons/md';

export default function VatInfoPopup({
  itemizedCosts,
  isPrivate = false,
}: {
  itemizedCosts: any;
  isPrivate?: boolean;
}) {
  const t = useTranslations('AuctionCurrentBid');
  const formatterPrice = useFormatterPrice();
  const [showVatPopup, setShowVatPopup] = useState(false);
  const itemCost = itemizedCosts?.total?.price_ex_vat;
  const totalCost = itemizedCosts?.total?.price_incl_vat;
  const totalVat = itemizedCosts?.total?.vat_amount;
  const ordinaryVat =
    itemizedCosts?.object?.vat_description === 'vat.ordinary' && !isPrivate;

  if (!totalCost) return null;

  return (
    <>
      <button
        type='button'
        onClick={() => setShowVatPopup(!showVatPopup)}
        className='text-positive'
      >
        <IoMdInformationCircleOutline />
      </button>
      {showVatPopup && (
        <div
          className='absolute -left-6 -right-6 top-full z-20 rounded-xl bg-[#FFDD93] p-6 pt-8'
          style={{ boxShadow: '0 4px 16px rgba(0, 0, 0, 1)' }}
        >
          <button
            type='button'
            onClick={() => setShowVatPopup(false)}
            className='absolute right-2 top-2 text-2xl'
          >
            <MdClose />
          </button>
          <table className='w-full text-left text-sm'>
            <thead>
              <tr>
                <th className='py-1'>{t('description')}</th>
                <th className='py-1 text-right'></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className='py-1'>
                  {ordinaryVat ? t('itemCost') : t('itemCostVatExempt')}
                </td>
                <td className='py-1 text-right'>
                  {formatterPrice(
                    itemCost,
                    String(getOption('DEFAULT_LOCALE'))
                  )}
                </td>
              </tr>
              <tr>
                <td className='py-1'>
                  {ordinaryVat ? t('vat') : t('salesVat')}
                </td>
                <td className='py-1 text-right'>
                  {formatterPrice(
                    totalVat,
                    String(getOption('DEFAULT_LOCALE'))
                  )}
                </td>
              </tr>
            </tbody>
            <tfoot className='border-t border-black font-bold'>
              <tr>
                <td className='pt-2'>{t('total')}</td>
                <td className='pt-2 text-right'>
                  {formatterPrice(
                    totalCost,
                    String(getOption('DEFAULT_LOCALE'))
                  )}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </>
  );
}
